<div class="content-wrapper table-full-bx recuiterjobpost mt-0 positionStatic">
    <div class="progress" >
        <div class="progress-bar" role="progressbar" aria-label="Basic example" style="width:5%" aria-valuenow="15" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
    <div class="page-content">

        <div class="row">
            <div class="col-lg-12">
                <div class="ibox jobScreen">
                    <div class="ibox-body">
                        <div class="iboxcontent">
                            <h3>Post Job</h3>
                            <p>How would you like to post your job?</p>
                        </div>
                        <!-- Checkbox -->
                        <div class="post">
                            <div class="row">
                                <div class="col-md-6 customBox" (click)="checkListData();" [ngClass]="allJobs == 0 ? 'disabled':''">
                                    <div class="customradiobox" (click)="selectedType($event,0)">
                                        <div class="custom_radio">
                                            <input type="radio" id="featured-1" name="featured" [checked]="jobType==0">
                                            <label for="featured-1">
                                                <span class="plan-details">
                                                    <p class="plan-type">Use a previous job as a template</p>
                                                    <p class="plan-cost">Copy a past posted job and edit as required</p>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="customradiobox" (click)="selectedType($event,1)">
                                        <div class="custom_radio">
                                            <input type="radio" id="featured-2" name="featured" [checked]="jobType==1">
                                            <label for="featured-2">
                                                <span class="plan-details">
                                                    <p class="plan-type">Start with a new job</p>
                                                    <p class="plan-cost">Use our job creation tool</p>
                                                </span>

                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end -->

                            <div class="" id="previousTemplate" *ngIf="jobType == 0">
                                <!-- searchbox -->
                                <div class="flexbox mb-4 ">
                                    <div></div>
                                    <div class="input-group-icon input-group-icon-left ">
                                        <div class="col-list-right">
                                            <form (ngSubmit)="searchFun()">
                                                <div class="form-group">
                                                    <span class="input-icon input-icon-right font-16"><img src="assets/images/search.svg"></span>
                                                    <input type="text" [(ngModel)]="search" autocomplete="off" class="form-control form-control-rounded form-control-solid"
                                                        name="search" id="key-search" placeholder="Search by Title,Skills" />
                                                    <span *ngIf="search" class="closeSearch" (click)="clearSearch()">&times;</span>
                                                    <ul *ngIf="allJobs?.length > 0" class="searchPannel">
                                                        <li *ngFor="let item of allJobs">
                                                            {{item?.name}}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                </div>
                                <!-- end -->
                                <!-- Table -->
                                <div class="table-scroll smalltab table-wrapper  table-responsive">
                                    <table id="example" class="table table-bordered table-hover m-0  " style="width: 100%;">
                                        <thead>
                                            <tr>
                                                <th class="sorting_asc">Job title</th>
                                                <th class="sorting_asc"> Date posted </th>
                                                <th class="sorting_asc"> Skills</th>
                                                <th class="sorting_disabled" data-orderable="false"> Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- 1 -->
                                            <tr *ngFor="let data of allJobs | paginate: { id:'pagination', itemsPerPage: pagination.limit, currentPage: currentPage ,totalItems: pagination.totalItems};let i=index"> 
                                                <td><a href="javascript:void(0);">{{data.jobTitle}}</a></td>
                                                <td><a href="javascript:void(0);">{{data.createdAt | date: "d/M/YYYY h:mm a"}}</a></td>
                                                <td>
                                                    <a href="javascript:void(0);">
                                                        <span *ngFor="let skill of data.job_post_skills" class="skills">
                                                            {{skill?.skill?.name || "N/A"}} 
                                                        </span>
                                                    </a>
                                                </td>
                                                <td><div class="action-wrap table-action">
                                                    <a (click)="selectJobId(data.id,i,$event)" [ngClass]="data.selected == true ? 'selected' : ''"><span>
                                                        <input type="radio" id="selectId" name="selectId"> 
                                                        Select
                                                        <span class="showSelectd" *ngIf="data.selected == true"><img src= "assets/images/ic_selected_check.svg"> Selected</span> 
                                                    </span></a>
                                                </div></td>
                                            </tr> 
                                        </tbody>
                                    </table>
                                    <div class="noDataFound" *ngIf="allJobs == 0">
                                        <h2>No records found</h2>
                                    </div>
                                </div>
                                <div class="col-sm-12 p-0" *ngIf="allJobs.length > 9">
                                    <ul class="pagination ">
                                        <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;" nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls> 
                                         </ul>
                                </div>

                                <!-- end -->
                                <div class="mt-4" *ngIf="allJobs.length > 0">
                                    <a class="planbtn fill" href="javascript:void(0)" (click)="redirectTo()">Continue</a>
                                    <div class="text-danger" *ngIf="showError">
                                        *Please select at one record from table.
                                    </div>
                                </div>
                            </div>
                            <div class="" id="startNew" *ngIf="jobType == 1">
                                <div class="mt-4">
                                    <a class="planbtn fill" href="javascript:void(0)" (click)="reDirectTo()">Continue</a>
                                </div>
                            </div>
                        </div>



                    </div>
                </div>


            </div>

        </div>
    </div>

    <!-- End -->